import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { addAlert, useMaterialUIController } from "context";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import React, { useEffect } from "react";
import { addGeneralCodeDO, getGeneralCodes } from "utils/generalCodesUtils";
import { GeneralCodeDialogProps } from "./AddGeneralCodeDialog";
import { Autocomplete } from "@mui/material";

const MDInput = require("components/MDInput").default;

export const UpdateGeneralCodeDialog = ({ type, entity, onChange }: GeneralCodeDialogProps) => {
  const [controller, dispatch] = useMaterialUIController();
  const [code, setCode] = React.useState({} as GeneralCode);
  const [codes, setCodes] = React.useState([] as GeneralCode[]);
  useEffect(() => {
    getGeneralCodes(type).then((res) => setCodes(res));
  }, [type]);
  return (
    <AloveDialog
      dialogType={DialogType.UpdateGeneralCode}
      dialogTitle={`Set ${entity}`}
      dialogBody={`Update the name of the ${entity} you want to set`}
      dialogConfirm="Update"
      valid={!!code.name}
      handleConfirm={() => onChange!(code)}
    >
      <Autocomplete
        options={codes}
        getOptionLabel={(option) => option.name}
        onChange={(_, value) => setCode(value!)}
        renderInput={(params) => (
          <MDInput
            {...params}
            label={`${entity} Name`}
            required
          />
        )}
      />
    </AloveDialog>
  );
};
